// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__cNheu","company_logo":"Sidebar_company_logo__5M98E","menu_item":"Sidebar_menu_item__lU2IV","active":"Sidebar_active__40ppP"};